// React Calendar
import Calendar from 'react-calendar';

// uuid
import { v4 as uuidv4 } from 'uuid';

// Components
import Button from 'components/General/Button/Button';
import TimeSlot from 'components/Onboarding/TimeSlot/TimeSlot';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { CreateSession, setCalendarDate, setCalendarMonth } from './CreateSession.slice';

// Logic
import { useLogic } from './CreateSession.logic';

// Moment
import moment from 'moment-timezone';

// React
import { FC } from 'react';

// Components
import { OverlayLoader, SectionLoader } from 'components/General/Loader/Loader';

// Tooltip
import ReactTooltip from 'react-tooltip';

// Redux
import onboarding, { OnboardingSlice } from 'pages/Onboarding/OnboardingSlice';
import { Col, Row } from 'react-grid-system';

// Style
import './CreateSession.scss';
import { Toggle } from 'components/Dashboard/CheckBox/CheckBox';
import Dropdown from 'components/General/Dropdown/Dropdown';

const CreateSessionCalendar: FC<any> = () => {
  const dispatch = useDispatch();
  const onboardingState = useSelector((state: { onboarding: OnboardingSlice }) => state.onboarding);
  const { calendarDate } = useSelector((state: { calendar: CreateSession }) => state.calendar);
  const {
    availableDates,
    isLoadingInitialAvailableDates,
    isLoadingAvailableDates,
    isLoadingAvailableTimes,
    handleCreateSession,
    isTeacher,
    isAdmin,
    timeSlots,
    setActiveOpenCalendar,
    activeOpenCalendar,
    isLoadingAllTimeSlots,
    isLoading,
    duration,
    setDuration,
    durations,
    isLoadingCreateSession,
    appointmentTypeIds,
    className
  } = useLogic();

  return (
    <div className="calendar-container">
      <div className="calendar-card">
        <h2>Add extra session</h2>
        {(!isTeacher && !isAdmin) && <h3>Be careful you can change this session one time</h3>}
        {isLoadingInitialAvailableDates ? <SectionLoader />
          : (
            <>
              <div className="calendar-container">
                {(isLoadingAvailableDates) && <OverlayLoader />}
                <div className="admin-open-calendar mb-2">
                  <h3>Activate open calendar</h3>
                  <Toggle
                    checked={activeOpenCalendar}
                    onChange={() => setActiveOpenCalendar((prev) => !prev)}
                  />
                </div>
                <div className="slots-duration mb-2">
                  <Dropdown
                    options={durations}
                    onChange={(e) => setDuration(e.target.value)}
                    value={duration}
                  />
                </div>
                <Calendar
                  defaultValue={moment(onboardingState.plan.sessionDate).toDate() || new Date()}
                  defaultActiveStartDate={moment(onboardingState.plan.sessionDate).toDate() || new Date()}
                  maxDate={onboardingState.plan.typeID ? undefined : new Date()}
                  onActiveStartDateChange={(props) => { if (props.view === 'month') dispatch(setCalendarMonth(`${moment(props.activeStartDate).year()}-${moment(props.activeStartDate).month() <= 8 ? `0${moment(props.activeStartDate).month() + 1}` : moment(props.activeStartDate).month() + 1}`)); }}
                  onChange={(date: Date) => dispatch(setCalendarDate(date))}
                  minDate={onboardingState.plan.typeID ? undefined : new Date()}
                  tileDisabled={({ date, view }) => {
                    if (view !== 'month') { return false; }
                    const dates = availableDates?.data?.map((availableDate) => new Date(availableDate.date).toLocaleDateString());
                    if (activeOpenCalendar) {
                      return moment(moment().subtract(1, 'day')).diff(date.toLocaleDateString()) >= 0;
                    }
                    return dates?.filter((availableDate) => moment(date.toLocaleDateString()).isSame(availableDate)).length === 0;
                  }}
                  tileClassName={({ date }) => {
                    const dates = onboardingState.selectedTimeSlots?.map((availableDate) => new Date(availableDate.datetime).toLocaleDateString());
                    return dates?.filter((availableDate) => moment(date.toLocaleDateString()).isSame(availableDate)).length > 0 ? 'selected-date' : '';
                  }}
                />
              </div>
              {isLoading || (isLoadingAllTimeSlots) || (isLoadingAvailableTimes && !isLoadingAvailableDates) ? <div className="pt-3 pb-3"><SectionLoader /></div>
                : (
                  <div className="available-times">
                    <Row style={{ rowGap: 35 }}>
                      {timeSlots.length ? (
                        timeSlots.map((item) => (
                          <Col
                            xs={6}
                            md={6}
                            key={uuidv4()}
                          >
                            <TimeSlot
                              addTime={{
                                hours: duration.split(' ')[0],
                                type: duration.split(' ')[1].includes('hour') ? 'hours' : 'minutes'
                              }}
                              time={item}
                              onClick={() => dispatch(onboarding.actions.toggleTimeSlot({
                                appointmentTypeId: appointmentTypeIds[className || 'SAT'][durations.indexOf(duration)],
                                datetime: item
                              }))}
                              selected={onboardingState.selectedTimeSlots.some((slot) => slot.datetime.includes(item))}
                              deny={
                                // If the user scheduled all required sessions
                                onboardingState.selectedTimeSlots.length === 1
                                // Prevent the user from selecting two sessions in the same day
                                || onboardingState.selectedTimeSlots.filter((time) => moment(new Date(time.datetime).toLocaleDateString()).isSame(calendarDate?.toLocaleDateString())).length > 0
                              }
                            />
                          </Col>
                        ))
                      ) : (
                        <div className="no-times-available">
                          <h4>No available times</h4>
                        </div>
                      )}
                    </Row>
                  </div>
                )}

              <div className="buttons-container">
                <ReactTooltip />
                <Button
                  onClick={() => { if (onboardingState.selectedTimeSlots.length === 1) handleCreateSession(); }}
                  color="primary"
                  data-tip={onboardingState.selectedTimeSlots.length < (1 || 0) ? 'Please select a time.' : ''}
                  data-place="top"
                  data-type="warning"
                  data-effect="solid"
                  isLoading={isLoadingCreateSession}
                >
                  <>
                    Create session
                  </>
                </Button>
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default CreateSessionCalendar;
